import { getAuthorizationHeader } from "@brandclub/common-ui";
import axios from "../../../utils/axios";

export const generateAffiliateLink = async ({
  stacklineSku,
  retailerSku,
  retailerId,
}: {
  stacklineSku: string;
  retailerSku: string;
  retailerId: number;
}) => {
  return axios.post(
    "/affiliate/generateAffiliateLink",
    {
      stacklineSku,
      retailerSku,
      retailerId,
    },
    {
      headers: {
        ...(await getAuthorizationHeader()),
      },
    }
  );
};
